// extracted by mini-css-extract-plugin
export var list = "moreStories-module--list--3TDgg";
export var reading = "moreStories-module--reading--2jday";